import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import withEndpointAuthorization from '../../authorization/withEndPointAuthorization';
import { generateTicketAccountingDataEndpoint } from '../../../../config/endpoints';
import { POST } from '../../../../config/permissions';
import Table from '../../../common/Table';
import {
  BUSINESS_TICKET_CHANGE_HISTORY_COLUMNS,
  CUSTOMER_TICKET_CHANGE_HISTORY_COLUMNS,
} from '../../../../config/columns';

const TicketChangeHistoryComponent = ({ ticket }) => {
  const [show, setShow] = useState(false);
  const [hasBusiness, setHasBusiness] = useState(false);

  useEffect(() => {
    if (
      ticket &&
      ticket.ticketChangeHistoryList &&
      ticket.ticketChangeHistoryList.length > 0
    ) {
      setShow(true);

      const findBusiness = ticket.transactions.find(
        (transaction) => transaction.business !== null,
      );

      setHasBusiness(Boolean(findBusiness));
    }
  }, [ticket]);

  return show ? (
    <Row>
      <Col>
        <h3>Historial de Cambios Contables</h3>
        <Table
          data={ticket.ticketChangeHistoryList}
          columns={
            hasBusiness
              ? BUSINESS_TICKET_CHANGE_HISTORY_COLUMNS
              : CUSTOMER_TICKET_CHANGE_HISTORY_COLUMNS
          }
          defaultPageSize={ticket.ticketChangeHistoryList.length}
          showPagination={false}
          showPageSizeOptions={false}
          className="-striped -highlight"
        />
      </Col>
    </Row>
  ) : null;
};

TicketChangeHistoryComponent.propTypes = {
  ticket: PropTypes.shape({
    ticketChangeHistoryList: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        ticketId: PropTypes.number,
        createDate: PropTypes.number,
        changeType: PropTypes.string,
        userId: PropTypes.number,
        userName: PropTypes.string,
      }),
    ),
    transactions: PropTypes.arrayOf(
      PropTypes.shape({
        business: PropTypes.shape({}),
      }),
    ),
  }).isRequired,
};

export const mapDispatchToProps = {};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(TicketChangeHistoryComponent);

export default withEndpointAuthorization({
  url: generateTicketAccountingDataEndpoint(0),
  permissionType: POST,
})(connectedComponent);
